import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";

type Product = {
  _id: string;
  title: string;
  price: number;
  images: string[];
  colors: string[];
};

const apiUrl = process.env.REACT_APP_API_URL;

const fetchProducts = async (): Promise<Product[]> => {
  const res = await fetch(`${apiUrl}/api/products`);
  if (!res.ok) throw new Error("Erreur de récupération");
  return res.json();
};

export default function New() {
  const {
    data: products,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["products"],
    queryFn: fetchProducts,
    // ---- rafraîchissement auto toutes les 60s ----
    refetchInterval: document.visibilityState === "visible" ? 60_000 : false,
    // (optionnel) ne pas rafraîchir en plus lors d’un retour d’onglet
    refetchOnWindowFocus: false,
    // (optionnel) les données restent “fraîches” 30s
    staleTime: 30_000,
  });

  if (isLoading) return <div className="text-center py-12">Chargement...</div>;
  if (isError || !products)
    return <div className="text-center py-12">Erreur serveur</div>;

  return (
    <div className="flex flex-col items-center gap-8">
      <h2 className="text-4xl font-bold">Nouveautés</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {products.map((product) => (
          <div
            key={product._id}
            className="p-4 flex flex-col items-center w-80"
          >
            <Link to={`/product/${product._id}`} className="w-full block">
              <img
                src={product.images[0]}
                alt={product.title}
                className="w-full h-64 object-cover rounded-md mb-3 transition-transform duration-300 hover:scale-105"
                loading="lazy"
              />
            </Link>

            <div className="text-center text-sm font-semibold">
              {product.title}
            </div>

            <div className="mt-2 text-sm font-medium">{product.price}€</div>

            <div className="flex items-center gap-2 mt-3">
              {product.colors.map((color, i) => (
                <div
                  key={i}
                  className={`w-4 h-4 rounded-full border ${
                    color === "white"
                      ? "bg-white border-gray-400"
                      : `bg-${color}`
                  }`}
                ></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
